import { dateFunc } from "@/components/Functions/dateFunc";
import { useTranslation } from "react-i18next";

export const useSchemeColumnDefinition = () => {
    const { t } = useTranslation();
    return [
        {
            cellRenderer: "nameCellRenderer",
            headerName: t("pages.configuration.schemes.columnDetails.column1"),
            comparator: () => 0,

            field: "name",
            type: "nameType",
            flex: 1,
            sortable: true,
            unSortIcon: true,
            minWidth:150
        },
        {
            headerName: t("pages.configuration.schemes.columnDetails.column2"),
            comparator: () => 0,
            field: "description",
            type: "descriptionType",
            flex: 1,
            sortable: true,
            unSortIcon: true,
            wrapText: true,
            autoHeight: true,
            cellClass:"overFlowWrapAnywhere",
            minWidth:150

        },
        {
            headerName: t("pages.configuration.schemes.columnDetails.column3"),
            comparator: () => 0,

            field: "effectiveDate",
            type: "effectiveDateType",
            flex: 1,
            sortable: true,
            unSortIcon: true,
            cellRenderer: function (params: any) {
                return dateFunc(params.data.effectiveDate).formattedDateOnly;
            },
            minWidth:150

        },
        // {
        //     headerName: "",

        //     field: "actions",
        //     cellRenderer: "actionCellRenderers",
        //     flex: 1,
        //     sortable: false,
        // },
    ]
};